<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M14.83 4.344h.793c.747 0 1.353.61 1.353 1.36v8.462c0 .833.273 1.17 1.19 1.17h7.474c.747 0 1.354.61 1.354 1.36v.845h-.02c-.355 6.574-5.656 11.792-12.144 11.792-6.718 0-12.164-5.594-12.164-12.494 0-6.9 5.446-12.495 12.164-12.495z"/><path d="M19.085 3.992c0-.846.767-1.51 1.578-1.28a7.7 7.7 0 01.569.183c3.816 1.409 6.785 4.642 7.91 8.675.064.23.12.467.167.708.157.792-.485 1.496-1.289 1.496h-7.581a1.357 1.357 0 01-1.354-1.36V3.992z"/></g></svg>
</template>

<script>
export default {
  name: 'symbolsPieChartFilled'
}
</script>
